// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class SearchPreference extends TrackingModel {
	public SearchPreferenceId: number = 0;
	public SitePreferencesSetId: number = 0;
	public SearchRequestTypeId: number = 0;
	public DefaultSearchRequestId?: number;
	public IsRunDefaultSearchOnLoad: boolean = false;
}